export enum EDataFieldTypes {
    STRING = 'string',
    NUMBER = 'number',
    DATE = 'date',
    BOOLEAN = 'boolean',
    ENUM = 'enum',
    LIST = 'list',
    OBJECT_ID = 'ObjectId',
    OBJECT = 'object'
}

export enum EDataFieldFormatter {
    NONE = 'none',
    CURRENCY = 'currency'
}

export enum EDataFieldCollectionName {
    CAMPAIGN_ITEM = 'RLCampaignItem',
    PRODUCT = 'RLProduct',
    ASSET = 'RLAsset'
}

export enum EDataCollectionName {
    CAMPAIGN = 'RLCampaign',
    PROJECT = 'RLProject',
    STICKY_NOTE = 'RLStickyNote',
    PUBLICATION_ITEM = 'RLPublicationItem',
    STATIC_CONTENT_RULE_SET = 'RLStaticContentRuleset',
    PUBLICATION = 'RLPublication',
    TEMPLATE = 'RLTemplate',
    WORKFLOW_AUTOMATION = 'RLWorkflowAutomation'
}

export enum EChangeLogCollectionName {
    CAMPAIGN_ITEM = 'RLCampaignItem',
    NOTE = 'RLStickyNote'
}

export enum ENucBooleanText {
    TRUE = 'Yes',
    FALSE = 'No',
    EMPTY = 'Empty'
}

export enum RULESET_OPERATORS {
    OR = 'OR',
    AND = 'AND'
}

export enum EStickyNoteStatus {
    NEW = 'NEW',
    CREATED = 'CREATED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    PROCESSED = 'PROCESSED',
    REJECTED = 'REJECTED',
    COMPLETED = 'COMPLETED',
    DUPLICATE = 'DUPLICATE',
    DELETED = 'DELETED'
}

export enum ERequestMethod {
    POST = 'POST',
    GET = 'GET',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE'
}

export enum EExportType {
    XLS = 'XLS',
    CSV = 'CSV',
    XLIFF = 'XLIFF'
}

export enum EKeyCodes {
    SPACE = 'Space',
    ARROW_LEFT = 'ArrowLeft',
    ARROW_UP = 'ArrowUp',
    ARROW_RIGHT = 'ArrowRight',
    ARROW_DOWN = 'ArrowDown',
    ENTER = 'Enter',
    DELETE = 'Delete',
    BACKSPACE = 'Backspace'
}

export enum EKeyboardKeys {
    Z = 'z',
    Y = 'y'
}

export enum EChannel {
    PRINT = 'PRINT',
    DIGITAL = 'DIGITAL'
}

export enum EFormStatus {
    VALID = 'VALID',
    INVALID = 'INVALID'
}

export enum ECursorTypes {
    GRAB = 'grab',
    GRABBING = 'grabbing',
    POINTER = 'pointer'
}

export enum ERuleStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED'
}

export enum ERuleStatusTitle {
    ENABLE = 'Enable',
    DISABLE = 'Disable'
}
